
export const getConfig = state => state.leadForm.config;
export const getEvent = state => state.leadForm.event;
export const getIsSubmitting = state => state.leadForm.isSubmitting;
export const getTimeLeft = state => state.leadForm.timeLeft;
export const getIsResendVisible = state => state.leadForm.isResendVisible;
export const getIsOtpInvalid = state => state.leadForm.isOtpInvalid;
export const getIsLeadFormVisible = state => state.leadForm.isLeadFormVisible;
export const getIsHomeLeadFormVisible = state => state.leadForm.isHomeLeadFormVisible;
export const getBasicDetails = state => state.leadForm.basicDetails;

export const getFreeFoodLeadFormVisibleState = state => state.leadForm.freeFoodLeadFormVisibleState;
export const getConnectVmLeadFormVisibleState = state => state.leadForm.connectVmLeadFormVisibleState;
export const getHaveUsCallYouFormVisibleState = state => state.leadForm.haveUsCallYourFormVisibleState;
export const getIsShowOtpSegmentForFFTVM = state => state.leadForm.showOtpSegmentForFFTVM;

export const getVendorLeadFormVisibleState = state => state.leadForm.isVendorLeadFormVisible;
export const getVendorSelectedId = state => state.leadForm.vendorSelectedId;
export const getIsShowOtpSegmentForVendorLeadForm = state => state.leadForm.showOtpSegmentForVendorLeadForm;
export const getIsWrongOtpEntered = state => state.leadForm.isWrongOtpEntered;
export const getEnquiryFormParams = state => state.leadForm.enquiryFormParams
export const getEnquiryFormVisibilityState = state => state.leadForm.enquiryFormVisibleState
export const getSideBarHaveUsCallYouFormStatus = state => state.leadForm.sideBarHaveUsCallYouFilled
export const getSelectedCatagory = state => state.leadForm.selectedCatagory
export const getSelectedLeadFormType = state => state.leadForm.leadFormType
export const getLeadFormTriggerCode = state => state.leadForm.leadFormTriggerCode
